import { useMemo, useState } from "react";
import { feedItems } from "@/mocks/homeData";
import { CatSolid, SectionHead, Shell } from "./ui";

const filters = ["全部", "反转", "打脸", "辟谣", "实锤", "追踪"];

export default function BreakingFeed() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? feedItems : feedItems.filter((f) => f.cat === active)),
    [active]
  );

  return (
    <section className="bg-background-50">
      <Shell>
        <div className="py-10 md:py-14">
          <SectionHead
            id="break"
            kicker="Live Feed · 实时滚动"
            title="反转与辟谣实时进展"
            subtitle="按类别逐条跟进最新说法、最新实锤与最新打脸，标题+短摘要速览，点击可展开来龙去脉。"
            linkText="更多实时短讯"
          />

          {/* 类别筛选 */}
          <div className="mb-6 flex flex-wrap items-center gap-2">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium transition ${
                  active === f
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          {/* 密集卡片并行 */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {list.map((it) => (
              <article
                key={it.id}
                className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-primary-200"
              >
                <div className="relative h-32 w-full overflow-hidden md:h-36">
                  <img
                    src={it.src}
                    alt={it.title}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2.5 top-2.5">
                    <CatSolid cat={it.cat} />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-3.5">
                  {it.tag ? (
                    <span className="mb-1.5 inline-flex w-fit items-center gap-1 rounded border border-accent-200 bg-accent-100/70 px-1.5 py-0.5 text-[10px] font-semibold text-accent-900">
                      <i className="ri-flashlight-line" />
                      {it.tag}
                    </span>
                  ) : null}
                  <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-800">
                    <a href="#top">{it.title}</a>
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">{it.summary}</p>
                  <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-foreground-400">
                    <span className="inline-flex items-center gap-1"><i className="ri-time-line" />{it.time}</span>
                    <span className="inline-flex items-center gap-1 font-semibold text-accent-700"><i className="ri-fire-line" />{it.heat}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Shell>
    </section>
  );
}